import { MembershipPlan } from "./schemas";

export type CoachStatus = "founding" | "featured" | "pro" | "proplus";

export interface CoachStatusSource {
  readonly membershipPlan: MembershipPlan;
  readonly isFeaturedCoach?: boolean | null;
  readonly isFoundingCoach?: boolean | null;
}

export const deriveCoachStatuses = ({
  membershipPlan,
  isFeaturedCoach,
  isFoundingCoach,
}: CoachStatusSource): CoachStatus[] => {
  const statuses: CoachStatus[] = [];

  if (membershipPlan === MembershipPlan.ProPlus) {
    statuses.push("proplus");
  } else if (membershipPlan === MembershipPlan.Pro) {
    statuses.push("pro");
  }

  if (isFeaturedCoach === true) {
    statuses.push("featured");
  }

  if (isFoundingCoach === true) {
    statuses.push("founding");
  }

  return statuses;
};
